import React from "react";
import { Form, FormItem, Input, Select } from "formik-antd";
import { Button, Form as AntForm } from "antd";
import { formItemLayout, tailFormItemLayout } from "../../utils";
import { ImageUpload } from "../../components";
import { Formik } from "formik";
import * as Yup from "yup";
import { useTranslate } from "../../hooks";

const FormSchema = () => Yup.object({
  name: Yup.string().required(),
  icon: Yup.string().required()
});

const ProjectForm = ({ action, onSubmit, onCancel }) => {
  const { translate } = useTranslate();
  const [data] = React.useState({
    name: undefined,
    icon: undefined,
    ...(action && action[0] === "update" ? action[1]: {})
  });

  return (
    <Formik
      enableReinitialize
      initialValues={data}
      validationSchema={FormSchema}
      onSubmit={onSubmit}>
      {({ isSubmitting }) => {
        return (
          <Form {...formItemLayout}>
            <FormItem name="name" label={translate("property.type.form.name", "Name")} required>
              <Input name="name" placeholder={translate("property.type.form.name", "Name")} />
            </FormItem>
            <FormItem name="icon" label={translate("property.type.form.image", "Image")}>
              <ImageUpload action="/api/general/upload" name="icon" />
            </FormItem>
            <AntForm.Item {...tailFormItemLayout}>
              <Button className="button" style={{ marginRight: 10 }} htmlType="submit" type="primary" loading={isSubmitting}>{translate("system.btn.save", "Save")}</Button>
              <Button className="button" type="default" onClick={onCancel}>{translate("system.btn.cancel", "Cancel")}</Button>
            </AntForm.Item>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ProjectForm;